import {
  ANNOUNCEMENT_FETCHING,
  ANNOUNCEMENT_FAILED,
  ANNOUNCEMENT_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case ANNOUNCEMENT_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case ANNOUNCEMENT_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case ANNOUNCEMENT_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
